export default __webpack_public_path__ + "static/media/Datatype.0f4df194.svg";